import React from 'react'
import Button from 'components/button/Button'
import { buttons } from './CONTENT'
import { Wrapper } from './OperationsStyled'
// import { allIn } from './functions/allIn'
// import SFXS from '../../../assets/audios/audios'

interface OperationsProps {
  makeMathOperation: any
   colors: any
 }
export default function Operations({
  makeMathOperation,

  colors,
}: OperationsProps) {
  return (
    <Wrapper data-testid='operationsWrapper'>
      {buttons.map((b, i) => (
        <Button
          func={(e?: boolean) => makeMathOperation(e ? b.name : e)}
          longPressEnabled={b.longPressEnabled}
          key={i}
          SFX={b.SFX}
          borderColor={colors.secondary}
          background={colors.secondaryDark}
          textColor={colors.tertiary}
        >
          {b.content}
        </Button>
      ))}
    </Wrapper>
  )
}
